import { render, staticRenderFns } from "./pattern-preview-menu.vue?vue&type=template&id=4381ff56&scoped=true&lang=pug&"
import script from "./pattern-preview-menu.vue?vue&type=script&lang=ts&"
export * from "./pattern-preview-menu.vue?vue&type=script&lang=ts&"
import style0 from "./pattern-preview-menu.vue?vue&type=style&index=0&id=4381ff56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381ff56",
  null
  
)

export default component.exports